import { useTranslation } from "react-i18next";
import styled from "styled-components";
import media from "../../styles/media";
import Container from "../ui/Container";
import partners from "../../assets/img/partners.png";

const Wrapper = styled.section`
  padding: 56px 0;
  background-color: ${({ theme }) => theme.colors.surfaceAlt};

  ${media.md} {
    padding: 32px 0;
  }
`;

const Title = styled.h2`
  margin-bottom: 28px;
  font-size: ${({ theme }) => theme.fontSizes.h3};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`;

/**
 * Логотипы партнёров — одна широкая картинка. Раньше ей задавали
 * `width: 1600px` и потом переопределяли на четырёх брейкпоинтах.
 */
const Logos = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export function PartnersSection() {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container>
        <Title>{t("partners")}</Title>
        <Logos src={partners} alt={t("partners")} loading="lazy" />
      </Container>
    </Wrapper>
  );
}

export default PartnersSection;
